import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Protects routes: only allows access if the user is logged in (has auth data in localStorage).
 * If not logged in, redirects to /login so the user cannot access protected pages via URL.
 */
export const authGuard: CanActivateFn = (_route, state) => {
  const platformId = inject(PLATFORM_ID);
  const auth = inject(AuthService);
  const router = inject(Router);

  // SSR has no localStorage — defer auth check to the browser to avoid login flicker on refresh.
  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  if (auth.isLoggedIn()) {
    return true;
  }

  if (auth.hasExpiredSession()) {
    auth.handleSessionExpired();
    return false;
  }

  const returnUrl =
    state.url && state.url !== '/login' ? state.url : null;
  return router.createUrlTree(
    ['/login'],
    returnUrl ? { queryParams: { returnUrl } } : {},
  );
};
